import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'

/**
 * @deprecated
 * Need to delete after removing Vue.
 * src/app/shared/layouts/GlobalAccessLayout/config/ruleAgency.ts - new logic
 */
export const AccessOrganizationLayout = observer(() => {
  const [loading, setLoading] = useState(true)
  const { organizationStore, subscriptionStore } = useEntitiesContext()

  useEffect(() => {
    Promise.all([organizationStore.initPromise, subscriptionStore.initPromise])
      .then(() => {
        if (subscriptionStore.isAgencyWithoutSubscription) {
          uiStore.changeRoute({ path: '/clients' })
        }
      })
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className={'spinner'}>
        <SpinnerLoader ariaLabel={'AccessOrganizationLayout'} />
      </div>
    )
  }

  return <Outlet />
})
